export const enum AsyncDataStatus {
  IDLE = 'idle',
  SUCCESS = 'success',
  ERROR = 'error',
  PENDING = 'pending'
}
